import Container from "react-bootstrap/Container";
import { Card, Form, Row, Col } from "react-bootstrap";
import logo from "../images/logo.webp";
import DateRangeComp from "./DateRangeComp";
import Button from "react-bootstrap/Button";
import React, { useState } from "react";
import Nav from "react-bootstrap/Nav";
import { Scrollbars } from "react-custom-scrollbars";
import Slider from "react-slick";
import LeadsByMonthGraph from "../Grpahs/LeadsByMonthGraph";
import common, { checkStatus } from "../core/common";
import moment from "moment/moment";
import { useNavigate } from "react-router-dom";

// db imports
// import db from "../database/db.json";
// import db1 from "../database/db1.json";
// import YearToDateVisualGraph from "../Grpahs/YearToDateVisualGraph";

import LeadsByMonth from "../database/LeadsByMonth.json";
import TotalLeadsByCountry from "../database/TotalLeadsByCountry.json";
import Header from "./Header";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { LeadMarketing2Model } from "../model/LeadMarketing2Model";
import {
  getLMReport1,
  getLMReport2,
  getLMReport3,
  getLMReport4,
  getLMReport5,
} from "../action/LeadMarketing2Action";
import Meta from "./Meta";
import Campaign from "../SubComponents/Campaign";
import Qualifies from "../SubComponents/Qualifies";
import Users from "../SubComponents/Users";
import Branch from "../SubComponents/Branch";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getCampaignList } from "../action/CampaignAction";

export const LeadMarketing = () => {
  const navigate=useNavigate();
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
  };
  const dispatch = useDispatch();
  const { loading, error, rep1Data } = useSelector((s) => s.report1);
  const { loading: ld2, error: er2, rep2Data } = useSelector((s) => s.report2);
  const { loading: ld3, error: er3, rep3Data } = useSelector((s) => s.report3);
  const { loading: ld4, error: er4, rep4Data } = useSelector((s) => s.report4);
  const { loading: ld5, error: er5, rep5Data } = useSelector((s) => s.report5);

  const [leadMarketingJson, setLeadMarketingJson] =
    useState(LeadMarketing2Model);

  const getReport1 = () => {
    dispatch(getLMReport1(leadMarketingJson));
  };
  const getReport2 = () => {
    dispatch(getLMReport2(leadMarketingJson));
  };
  const getReport3 = () => {
    dispatch(getLMReport3(leadMarketingJson));
  };
  const getReport4 = () => {
    dispatch(getLMReport4(leadMarketingJson));
  };
  const getReport5 = () => {
    dispatch(getLMReport5(leadMarketingJson));
  };

  const setLeadMarktingModel = (e, gn = "", value = "") => {
    if (value === "") {
      setLeadMarketingJson({
        ...leadMarketingJson,
        [e.target.name]: e.target.value,
      });
    } else if (gn === "datefrom1" || gn === "dateto1") {
      var dt = moment(value).format("YYYY/MM/DD");
      let dat = gn.replace("1", "");
      setLeadMarketingJson({ ...leadMarketingJson, [gn]: value, [dat]: dt });
    } else if (value === "clear") {
      if (gn == "dateboth") {
        setLeadMarketingJson({
          ...leadMarketingJson,
          datefrom1: "",
          dateto1: "",
          datefrom: "",
          dateto: "",
        });
      } else {
        setLeadMarketingJson({ ...leadMarketingJson, [gn]: "" });
      }
    } else {
      setLeadMarketingJson({ ...leadMarketingJson, [gn]: value });
    }
    getReport1();
    getReport2();
    getReport3();
    getReport4();
    getReport5();
    getcampaigns();
  };

  const {
    loading: loadingCamp,
    error: errorCamp,
    campaignRecords,
  } = useSelector((s) => s.campaignList);

  const getcampaigns = () => {
    dispatch(
      getCampaignList(
        leadMarketingJson.branchId ? leadMarketingJson.branchId : "0"
      )
    );
  };

  useEffect(() => {
    if (checkStatus()) {
      if (!rep1Data) getReport1();
      if (!rep2Data) getReport2();
      if (!rep3Data) getReport3();
      if (!rep4Data) getReport4();
      if (!rep5Data) getReport5();
      if (!campaignRecords) getcampaigns();
    }else{
      navigate("/")
    }
  }, [
    dispatch,
    rep1Data,
    rep2Data,
    rep3Data,
    rep4Data,
    rep5Data,
    campaignRecords,
  ]);

  return (
    <React.Fragment>
      <Header />
      <Meta title="Lead Marketing" />
      <Container fluid style={{ maxHeight: "80%" }}>
        <Row>
          <Col>
            <Container fluid>
              <Row className="header" style={{ marginTop: "1vh" }}>
                <Col xs={6} style={{ display: "flex", alignItems: "center" }}>
                  <img
                    src={logo}
                    className="d-inline-block align-top"
                    alt="logo"
                  />
                  <h2 style={{ fontSize: "190%" }}>
                    <strong>&nbsp;&nbsp;&nbsp; Lead Marketing</strong>
                  </h2>
                </Col>

                <Col xs={3}>
                  <Card className="text-center">
                    <Card.Header
                      style={{ backgroundColor: "black", color: "white" }}
                    >
                      Total Leads Generated
                    </Card.Header>
                    <Card.Body
                      style={{ paddingTop: "6px", textAlign: "center" }}
                    >
                      <b style={{ fontSize: "40px" }}>{rep1Data?.Rec}</b>
                    </Card.Body>
                  </Card>
                </Col>

                <Col xs={3}>
                  <Card className="text-center">
                    <Card.Header
                      style={{ color: "white", backgroundColor: "black" }}
                    >
                      Date Range
                      <div style={{ float: "right", fontSize: "15px" }}>
                        <a
                          onClick={() =>
                            setLeadMarktingModel("", "dateboth", "clear")
                          }
                        >
                          Clear
                        </a>
                      </div>
                    </Card.Header>
                    <Card.Body style={{ paddingTop: "1px" }}>
                      {/* <DateRangeComp /> */}
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <DatePicker
                          style={{ maxWidth: "150px" }}
                          name="datefrom1"
                          selected={leadMarketingJson.datefrom1}
                          onChange={(date) =>
                            setLeadMarktingModel("", "datefrom1", date)
                          }
                          placeholderText="Date From"
                        />
                        <label>-to-</label>
                        <DatePicker
                          style={{ maxWidth: "150px" }}
                          name="dateto1"
                          selected={leadMarketingJson.dateto1}
                          onChange={(date) =>
                            setLeadMarktingModel("", "dateto1", date)
                          }
                          placeholderText="Date Till"
                        />
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row>
          <Col>
            <hr
              style={{
                height: "4px",
                borderWidth: "0",
                color: "black",
                backgroundColor: "black",
                marginTop: "7px",
                marginBottom: "5px",
              }}
            ></hr>
          </Col>
        </Row>
        <Row
          className="mdCard"
          style={{ marginTop: "10px", marginLeft: "15px", marginRight: "5px" }}
        >
          <Col md xl xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ", position: "initial" }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Lead Stage
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                  name="leadStage"
                  value={leadMarketingJson.leadStage}
                  onChange={(e) => setLeadMarktingModel(e, "", "")}
                >
                  <option value="">--- Select ---</option>
                  <Qualifies />
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>

          <Col md xl xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px ", position: "initial" }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select User
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "8px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                  name="userId"
                  value={leadMarketingJson.userId}
                  onChange={(e) => setLeadMarktingModel(e, "", "")}
                >
                  <option value="">--- Select ---</option>
                  <Users />
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col md xl xs={3}>
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                paddingTop: "0px",
                paddingBottom: "8px",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Branch
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Form.Select
                  aria-label="Default select example"
                  style={{ border: "none" }}
                  name="branchId"
                  value={leadMarketingJson.branchId}
                  onChange={(e) => setLeadMarktingModel(e, "", "")}
                >
                  <option value="">--- Select ---</option>
                  <Branch />
                </Form.Select>
              </Card.Body>
            </Card>
          </Col>
          <Col md xl xs={3}>
            <Card style={{ boxShadow: "2px 2px 8px " }}>
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Year
                <div style={{ float: "right" }}>
                  <a
                    onClick={() => setLeadMarktingModel("", "yearId", "clear")}
                  >
                    Clear
                  </a>
                </div>
              </Card.Header>
              <Card.Body style={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <Slider
                  {...settings}
                  className="slider"
                  style={{ margin: "1px" }}
                >
                  {common.years()
                    ? common.years().map((rec) => (
                        <div>
                          <Button
                            variant="secondary"
                            onClick={(e) =>
                              setLeadMarktingModel("", "yearId", rec)
                            }
                            className={
                              leadMarketingJson.yearId === rec ? "bg-pk" : ""
                            }
                          >
                            {rec}
                          </Button>
                        </div>
                      ))
                    : ""}

                  {/* <div>
                    <Button variant="secondary">2018</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2019</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2020</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2021</Button>
                  </div>
                  <div>
                    <Button variant="secondary">2022</Button>
                  </div> */}
                </Slider>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row style={{ marginTop: "20px", marginLeft: "25px" }}>
          <Col md xl xs={2} className="bCard1">
            <Card
              style={{
                boxShadow: "2px 2px 8px ",
                textAlign: "center",
                marginTop: "60px",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Avg Leads Inflow Per Day
              </Card.Header>
              <Card.Body>
                <b style={{ fontSize: 50 }}>
                  {rep2Data?.Rec ? rep2Data?.Rec : "---"}
                </b>
              </Card.Body>
            </Card>

            <Card
              style={{
                marginTop: "2px",
                boxShadow: "2px 2px 8px ",
                textAlign: "center",
                marginTop: "50px",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Lead Conversion Percentage
              </Card.Header>
              <Card.Body>
                <p style={{ marginBottom: "-1rem" }}>
                  {rep3Data?.positiveLeads} / {rep3Data?.totalLeads}
                </p>
                <b style={{ fontSize: 50 }}>{rep3Data?.Res} %</b>
              </Card.Body>
            </Card>
          </Col>
          <Col md xl xs={3}>
            <Card
              className="bcard2"
              style={{
                boxShadow: "2px 2px 8px ",
                position: "initial",
                height: "100%",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Total Leads By Total Stage
              </Card.Header>
              <Card.Body
                style={{
                  paddingBottom: "0px",
                  paddingTop: "0px",
                  height: "100%",
                }}
              >
                <LeadsByMonthGraph
                  graphType="bar"
                  db={rep4Data}
                  color="#472183"
                  height="400"
                  title="Lead Stage Records"
                />
              </Card.Body>
            </Card>
          </Col>
          <Col md xl xs={4}>
            <Card
              className="bcard2"
              style={{
                boxShadow: "2px 2px 8px ",
                height: "100%",
                position: "initial",
              }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Total Leads By Country
              </Card.Header>
              <Card.Body style={{ paddingBottom: "0px", paddingTop: "0px" }}>
                <LeadsByMonthGraph
                  graphType="bar"
                  db={rep5Data}
                  color="#873e23"
                  title="Country Records"
                />
              </Card.Body>
            </Card>
          </Col>
          <Col md xl xs={3}>
            <Card
              className="bcard2"
              style={{ boxShadow: "2px 2px 8px", height: "100%" }}
            >
              <Card.Header style={{ color: "white", backgroundColor: "black" }}>
                Select Campaign
              </Card.Header>
              <div
                className="card example-1 square scrollbar-cyan bordered-cyan"
                style={{ height: "-webkit-fill-available" }}
              >
                <div style={{ float: "right", paddingRight: 20 }}>
                  <a
                    onClick={(e) =>
                      setLeadMarktingModel(e, "campaignId", "clear")
                    }
                    style={{ float: "right" }}
                  >
                    Clear
                  </a>
                </div>
                <Card.Body className="campaign-card">
                  <Scrollbars>
                    <div style={{ paddingRight: "15px" }}>
                      <Nav variant="pills" className="flex-column">
                        <Campaign
                          clickFn={setLeadMarktingModel}
                          campaignRecords={campaignRecords}
                        />
                      </Nav>
                    </div>
                  </Scrollbars>
                </Card.Body>
              </div>
            </Card>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};
export default LeadMarketing;
